module.exports = __webpack_public_path__ + "fonts/ea36cd9.woff";